import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Typography, Button, Box } from "@mui/material";
import { analyticsPromise } from "../firebase-config"; // 👈 import GA
import { logEvent } from "firebase/analytics";

const ga = (eventName, params = {}) =>
  analyticsPromise?.then((analytics) => analytics && logEvent(analytics, eventName, params));

const Page404 = () => {
  useEffect(() => {
    ga("page_view", {
      page_location: window.location.href,
      page_path: window.location.pathname + window.location.search,
      page_title: "404 Page",
    });
    ga("404_error", {
      page_path: window.location.pathname,
      referrer: document.referrer || null,
    });
  }, []);

  return (
    <Box maxWidth="sm" sx={{ textAlign: "center", mt: 6 }}>
      <Typography variant="h2" color="error">
        404
      </Typography>
      <Typography variant="h5" gutterBottom>
        Oops! The page you're looking for doesn't exist.
      </Typography>
      <Typography variant="body1" color="text.secondary">
        The link may be broken, or the page may have been removed.
      </Typography>

      <Box mt={3}>
        <Button variant="contained" color="primary" component={Link} to="/">
          Go Back to Home
        </Button>
      </Box>
    </Box>
  );
};

export default Page404;
